import { useEffect } from 'react';

/**
 * Polls the target element every animation change for a change in `top` position.
 *
 * @param {import('react').RefObject<HTMLElement | null | undefined>} ref  Name or list of group names required to view/refresh this page.
 * @param {(top: number) => void} onPositionChange Callback
 */
const useTopPositionChange = (ref, onPositionChange) => {
  useEffect(() => {
    // @ts-expect-error: Nullish-check currently not enabled
    if (!ref.current) return;

    let animationFrame;
    let lastTop;

    const checkPosition = () => {
      const { top } = ref.current.getBoundingClientRect();
      if (top !== lastTop) {
        lastTop = top;
        onPositionChange(top);
      }
      animationFrame = requestAnimationFrame(checkPosition);
    };

    animationFrame = requestAnimationFrame(checkPosition);
    return () => cancelAnimationFrame(animationFrame);
  });
};
export default useTopPositionChange;
